// File Metadata:
// Filename: DashHome.js
// Version: 1.00
// Created: 2022-09-29 11:40:27
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React from 'react'
import useAuth from '../hooks/useAuth'
import { Link } from 'react-router-dom'
import './Home.css'

const DashHome = () => {
	const { username, isVoorman, isAdmin } = useAuth()
	return <div className='home'>Welcome {username}</div>
}

export default DashHome
